// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a5a28c03","239":"5c56935e","453":"2c7f2f0d","622":"1df1666d"}[chunkId] + ".chunk.js";
};